import { useState, useRef, useEffect } from "react";

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  direction?: 'up' | 'down';
}

export const Tooltip = ({ children, content, direction = 'down' }: TooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      
      if (direction === 'up') {
        setPosition({
          top: rect.top, // Top of the button
          left: rect.left + rect.width / 2, // Center of the button
        });
      } else {
        setPosition({
          top: rect.bottom, // Bottom of the button
          left: rect.left + rect.width / 2, // Center of the button
        });
      }
    }
  }, [isOpen, direction]);

  return (
    <>
      <div 
        ref={triggerRef}
        className="relative"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {children}
      </div>
      {isOpen && (
        <div 
          className="fixed z-[9999] pointer-events-none"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            transform: direction === 'up' ? 'translate(-50%, -100%)' : 'translate(-50%, 0)',
            marginTop: direction === 'up' ? '-8px' : '8px',
          }}
        >
          <div className="bg-base-raisinBlack/90 text-white p-2 rounded-lg text-sm whitespace-nowrap normal-case">
            {content}
          </div>
          <div 
            className={`absolute left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 ${
              direction === 'up' 
                ? 'top-full border-t-4 border-transparent border-t-base-raisinBlack/90' 
                : 'bottom-full border-b-4 border-transparent border-b-base-raisinBlack/90'
            }`}
          ></div>
        </div>
      )}
    </>
  );
};
